import React from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider, extendTheme, theme as baseTheme } from "@chakra-ui/react"; // Import 'theme'
import { ThemeProvider as MaterialTailwindProvider } from "@material-tailwind/react"; // ✅ Import this
import { HelmetProvider } from "react-helmet-async"; // ✅ NEW
import App from "./App";
import "./styles/index.css";

// Define custom Chakra UI theme
const chakraTheme = extendTheme({
  ...baseTheme, // Include the default Chakra UI theme
  colors: {
    ...baseTheme.colors, // Also include the default colors within your 'colors' object
    primary: {
      100: "#E3F2FD",
      500: "#2196F3",
      900: "#0D47A1",
    },
  },
  fonts: {
    heading: "Poppins, sans-serif",
    body: "Inter, sans-serif",
  },
});

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={chakraTheme}>
      <MaterialTailwindProvider>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </MaterialTailwindProvider>
    </ChakraProvider>
  </React.StrictMode>
);
